var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar"},_vm._l((_vm.count),function(n){return _c('div',{key:n,staticClass:"progress-bar-item"},[_c('div',{class:[
        'progress-bar-item-element',
        n > _vm.value ? 'progress-bar-item-disable' : '',
      ]})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }